// Browser storage isn't always usable: window.localStorage / window.sessionStorage is null in Android WebViews
// with DOM storage turned off, and reading the property throws when the visitor blocks site data
// (Safari "The operation is insecure.", Chrome "Access is denied for this document.").
// Unguarded, that throw stopped ws-tracking's init, so nothing was tracked on those pages.

const getStorage = (type, win) => {
	try {
		const scope =
			win === undefined && typeof window !== 'undefined' ? window : win;
		return scope?.[type] || null;
	} catch (e) {
		return null;
	}
};

const createSafeStorage = (type) => ({
	/**
	 * @param {string} key
	 * @param {Window} [win] Defaults to window
	 * @returns {string|null} The stored value, or null when missing or storage is unavailable
	 */
	getItem: (key, win) => {
		try {
			return getStorage(type, win)?.getItem(key) ?? null;
		} catch (e) {
			return null;
		}
	},
	/**
	 * Does nothing when storage is unavailable or full
	 *
	 * @param {string} key
	 * @param {string} value
	 * @param {Window} [win] Defaults to window
	 */
	setItem: (key, value, win) => {
		try {
			getStorage(type, win)?.setItem(key, value);
		} catch (e) {
			// storage unavailable or full
		}
	},
	/**
	 * Does nothing when storage is unavailable
	 *
	 * @param {string} key
	 * @param {Window} [win] Defaults to window
	 */
	removeItem: (key, win) => {
		try {
			getStorage(type, win)?.removeItem(key);
		} catch (e) {
			// storage unavailable
		}
	}
});

export const safeLocalStorage = createSafeStorage('localStorage');
export const safeSessionStorage = createSafeStorage('sessionStorage');
